import React, { FC } from 'react'
import { RenderBanner } from './subcomponent'

//* Helpers
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentMainNavBanner } from '../../../models/components/mainNavBanner'
import { returnSelectedLocaleData } from '../../../utils/functions.utils'
import mainNavBannerStaticQuery from './mainNavBannerStaticQuery'

type Props = {
  mainNavBannerData: ComponentMainNavBanner
  locale?: string
  navType: string
}

const MainNavBanner: FC<Props> = ({ mainNavBannerData, locale, navType }) => {
  const queryData = mainNavBannerStaticQuery?.allContentfulComponentMainNavBanner() || null
  let dynamicData: any = mainNavBannerData || queryData

  dynamicData = returnSelectedLocaleData(
    dynamicData?.allContentfulComponentMainNavBanner?.edges || [],
    locale || LocaleCodes.ENGLISH.code
  )

  const currentNav =
    navType === 'New Nav'
      ? mainNavBannerData
      : dynamicData?.find((entry: any) => {
          const now = new Date()
          const publishedData = new Date(entry?.node?.publishDate)
          const unpublishedData = new Date(entry?.node?.unpublishDate) > now
          return publishedData && unpublishedData
        })?.node

  return currentNav ? <RenderBanner currentNav={currentNav} navType={navType} /> : null
}

export default MainNavBanner
